import {Alert} from "components/ui";
import classes from "./TempMessage.module.scss";
/**
 *
 * @param props
 * @param {boolean} props.show
 * @param {string} props.variant 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light'
 * @param {string} props.message
 *
 * @returns {JSX.Element}
 * @constructor
 */
const TempMessage = (props) => {

    return  <div className={classes.box} style={props.style}><Alert className={classes.alert} show={props.show} variant={ props.variant ?? 'light'} >{props.message || props.children}</Alert></div>
}
export default TempMessage;